import * as React from "react";
import {FC, useEffect, useState} from "react";
import {webService} from "../api/web";
import {identity} from "./helpers";

interface IProps {
    children: React.ReactNode;
}

export const AuthToken: FC<IProps> = ({children}) => {
    const [loading, setLoading] = useState<boolean>(true);

    useEffect(() => {
        // Get token expiration from identity
        const {exp} = identity();

        // If a token exists, check if it expires within 5 minutes
        if (exp) {
            // Calculate the number of minutes until the token expires
            const expiresInMinutes = Math.floor((exp - (Date.now() / 1000)) / 60);

            // If the token does not expire within 15 minutes, render children immediately
            if (expiresInMinutes > 15) return setLoading(false);
        }

        // If token doesn't exist, get token from web service, then render children
        webService.identity
            .token()
            .catch()
            .finally(() => setLoading(false));
    }, []);

    return <>{!loading && children}</>
}